// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p_about-carat[data-v-df9cddf8]{text-align:center}.p_about-carat *[data-v-df9cddf8]{color:#3f3f3f;font-size:14px}.p_about-carat[data-v-df9cddf8]:before{content:\"\\f059\";position:relative;padding-right:3px;top:1px;font-family:Font Awesome\\ 5 Free;font-size:16px}.p_about-carat a[data-v-df9cddf8]:link,a[data-v-df9cddf8]:active,a[data-v-df9cddf8]:hover,a[data-v-df9cddf8]:visited{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
